import { Vue, Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { Badge, Dropdown, DropdownMenu, DropdownItem } from 'element-ui';
import TopMenu from '@acgn/herm/src/components/layout/TopMenu.vue';
import AccountButton from './account-button.vue';
import AcgnSide from './side.vue';
import AcgnBreadcrumb from '@acgn/herm/src/components/breadcrumb/index.vue';
import event from '@acgn/herm/src/util/event';
import './index.scss';

const Action = namespace('desk/comm').Action;
@Component({
  components: {
    [Badge.name]: Badge,
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    AcgnSide,
    AcgnBreadcrumb,
    TopMenu,
    AccountButton
  }
})
export default class Layout extends Vue {

  @Action private getAttributeData: any; // 获取全局基础类型列表

  private renderMenuFn: any = null;

  private hideRenderMenu: boolean = false;

  public render(h: any) {
    return (
      <el-container class="acgn-layout">
        <el-header class="acgn-layout__header">
          <TopMenu>
            <div slot="right" class="acgn-layout__header__top-menu__right-area">
              <account-button></account-button>
            </div>
          </TopMenu>
        </el-header>
        <el-container ref="elContainer">
          <div class={['acgn-side-box', this.hideRenderMenu ? 'hide-menu' : '']}>
            <acgn-side class="acgn-layout__container__aside acgn-side" />
            {this.renderMenuFn && this.renderMenuFn(h)}
          </div>
          <el-container>
            <el-header class="acgn-layout__container__breadcrumb-header">
              <acgn-breadcrumb />
            </el-header>
            <el-main>
              <router-view key={this.$route.path} class="acgn-layout__container__view" />
            </el-main>
          </el-container>
        </el-container>
      </el-container>
    );
  }

  private created() {
    this.getAttributeData();

    // 动态接收渲染菜单
    event.on('$renderMenuFn', (data: any) => {
      this.renderMenuFn = data;
    });

    // 动态菜单销毁
    event.on('$destroyRenderMenuFn', (data: any) => {
      this.renderMenuFn = null;
    });

    // 取消动态接收渲染菜单
    event.on('$togglerenderMenu', (data: any) => {
      this.hideRenderMenu = !this.hideRenderMenu;
    });
  }

  private mounted() {
    const height = document.body.clientHeight;
    const heightHeader = (document as any).querySelector('.acgn-layout__header').clientHeight;
    (this.$refs.elContainer as any).$el.style.height = (height - heightHeader) + 'px';
  }
}
